import { APISettings } from '../../config/ApiSettings';
import { CmsItemType } from '../enums/CmsItemType';
import { BaseAPI } from './baseApi';
// const baseUrl = APISettings.apiUrl;
const baseUrl = new APISettings().getApiURL();

class CmsAPI<CmsItem> extends BaseAPI {
  // constructor() {}

  public getCmsItems: () => Promise<CmsItem[]> = async () => {
    return (await BaseAPI.axios.get(`${baseUrl}/CmsItem/`)).data.output;
  };

  public updateCmsItem: (CmsItem: any) => Promise<CmsItem> = async (cmsItem: any) => {
    // This checks to see if the CMS item is html and encodes the HTML so it doesn't get caught by the firewall
    if (cmsItem.cmsItemValue != null && cmsItem.cmsTypeId === CmsItemType.Html) {
      let encodedCMSHtml = btoa(unescape(encodeURIComponent(cmsItem.cmsItemValue)));
      let encodedCmsItem = { ...cmsItem, cmsItemValue: encodedCMSHtml };
      return await BaseAPI.axios.put(`${baseUrl}/CmsItem`, encodedCmsItem);
    } else {
      return await BaseAPI.axios.put(`${baseUrl}/CmsItem`, cmsItem);
    }
  };
}

export const cmsAPI = new CmsAPI();
